import React, { useRef } from 'react';
import Button from './Button';
import ThemeToggle from './ThemeToggle';
import useSectionAnimation from 'hooks/animations/useSectionAnimation';
import VectorLoader from './VectorLoader';
import useMediaQuery from 'hooks/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const HeroSection = ({
  imageUrl,
  title,
  titleHighlight,
  subtitle,
  description,
  buttonText,
  showThemeToggle = false,
  loaderProgress,
  isLoading,
  buttonLink,
}) => {
  const backgroundRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);
  const isMobileSize = useMediaQuery();
  const navigate = useNavigate();

  const { backgroundImageUrl } = useSectionAnimation({
    backgroundRef,
    titleRef,
    descriptionRef,
    buttonRef,
    imageUrl,
    isLoading,
  });

  return (
    <div className='relative background-section-container overflow-hidden full-pager'>
      <div
        className='full-height full-width background-section absolute'
        style={{
          backgroundImage: backgroundImageUrl
            ? `url(${backgroundImageUrl})`
            : 'none',
        }}
        ref={backgroundRef}
      />
      <div className='hero-section full-height full-width flex flex-column z-1'>
        <div className='half-hero z-1 flex items-end hero-content items-end'>
          {subtitle && !isMobileSize && (
            <p
              className='paragraph-font-grotesk hero-subtitle font-white-color font-size-14 fp-p'
              ref={titleRef}
            >
              {subtitle}
            </p>
          )}
        </div>
        <div className='full-width flex items-center relative'>
          <p
            ref={titleRef}
            className={`img-page-font-grotesk font-white-color first-page-title-fs page-wrapper-x ${
              isMobileSize ? '' : 'absolute'
            }`}
          >
            {renderWithLineBreaks(title)} <br />
            {titleHighlight && (
              <span className='font-secondary'>
                {renderWithLineBreaks(titleHighlight)}
              </span>
            )}
          </p>
          <VectorLoader className='absolute' progress={loaderProgress} />
        </div>
        <div className='half-hero z-1 hero-content'>
          <div className='flex flex-column hero-section-des'>
            {isMobileSize && (
              <p
                className='paragraph-font-grotesk hero-subtitle font-white-color font-size-14 fp-p'
                ref={titleRef}
              >
                {subtitle}
              </p>
            )}
            {!isMobileSize && (
              <p
                ref={descriptionRef}
                className='paragraph-font-grotesk font-white-color'
              >
                {description}
              </p>
            )}
            {buttonText && buttonLink && (
              <Button ref={buttonRef} onClick={() => navigate(buttonLink)}>
                {buttonText}
              </Button>
            )}
            {showThemeToggle && (
              <ThemeToggle
                className={`${
                  isMobileSize ? '' : 'absolute hero-theme-toggle'
                }`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
